$( document ).ready(function() {
  var cutoff_time = localStorage.getItem('collection_cutOff');
  var DateTime = luxon.DateTime;
  var today_date = DateTime.now().setZone("Asia/Kuala_Lumpur");
  var now_timestamp = today_date.toMillis();
  var cart_collection = localStorage.getItem('cart_collection_list');
  console.log(today_date)
  function findDuplicates(arr) {
    var seen = {};
    var duplicates = [];
    
    for (let i = 0; i < arr.length; i++) {
      var element = arr[i];
  
      if (seen[element] && element !== 'Invalid DateTime') {
        duplicates.push(element);
      } else {
        seen[element] = true;
      }
    }
    
    return duplicates;
  }

  function findNonDuplicate(arr){
    const counts = {};
    arr.forEach(item => {
      counts[item] = (counts[item] || 0) + 1;
    });
    var array = arr.filter(item => counts[item] === 1);
    var result = array.filter((item) => item != "Invalid DateTime");
    
    return result;
  }
  

  $('body').on('click', '[action="next_step"]', async function(){ 
    await $.ajax({
      url: '/collections/cny-2022?view=inajax-collect-metafields',
      method: 'get'
    })
    .done((res) => {
      localStorage.removeItem('collection_cutOff')
      localStorage.removeItem('cart_collection_list')
      
      cutoff_time = JSON.parse(res)["cutoff_time"]
      cart_collection = JSON.parse(res)["collections"]

      
      if(cutoff_time.length > 0){
        cutoff_time = cutoff_time[0].split(',');
      }

      localStorage.setItem('cart_collection_list', JSON.stringify(cart_collection))
      localStorage.setItem('collection_cutOff', JSON.stringify(cutoff_time))
    })
    
    $(this).addClass('d-none');
    $(this).parents('.cart_mini_action_btns').find('[action="submit_cart_form"]').removeClass('d-none')
    $(this).parents('.widget_shopping_cart').find('.cart_item_content').addClass('d-none');
    $(this).parents('.widget_shopping_cart').find('.catr_mini_delivery ').removeClass('d-none')
    $(this).parents('.jas-mini-cart').find('.back_arrow ').removeClass('d-none')
    
  });
  
  $('body').on('click', '.jas-mini-cart .back_arrow', function(){ 
    $(this).parents('.jas-mini-cart').find('.cart_item_content').removeClass('d-none');
    $(this).parents('.jas-mini-cart').find('.catr_mini_delivery ').addClass('d-none');
    $(this).parents('.jas-mini-cart').find('[action="submit_cart_form"]').addClass('d-none')
    $(this).parents('.jas-mini-cart').find('[action="next_step"]').removeClass('d-none')
    $(this).addClass('d-none');

    $(".flatpickr-calendar.inline").hide()
    
  });
    
  $('body').on('click', '.order__dates-item-day', function(){
    var disable_dates = $('[data-disable-dates]').text();
    var cart_count = +$("[data-from-cart-count]").attr("data-from-cart-count") ;
    var global_cutoff_time = $('[data-global-collection-cutoff]').text();
    var cutoff_dates = [];
    
    if(typeof disable_dates === 'string'){
      disable_dates = disable_dates.split(",")
      disable_dates.pop()
      disable_dates = disable_dates.map((value) => value.trim())
    }
  
    if(cutoff_time.length < 0){
      cutoff_time = [];
    }else{
      if(typeof cutoff_time == 'string'){
        cutoff_time = JSON.parse(cutoff_time)
      }
    }
    
    if(typeof cart_collection == 'string'){
      cart_collection = JSON.parse(cart_collection)
    }
    // check today hours is bigger than global cut-off time
    if(today_date.hour >= DateTime.fromString(global_cutoff_time.trim(), 'HH:mm').setZone("Asia/Kuala_Lumpur").hour){
        cutoff_dates.push(today_date.toFormat('dd-MM-yyyy'));
    }
    
    if(Object.keys(cutoff_time).length > 0 && Object.values(cart_collection).length > 0){
        for (let index = 0; index < Object.values(cart_collection).length; index++) {
          var colletions = Object.values(cart_collection)[index];
          for (let index2 = 0; index2 < Object.keys(cutoff_time).length; index2++) {
            if(Object.values(colletions).find((ele) => ele === Object.keys(cutoff_time)[index2]) != undefined){
              var collection_name = Object.keys(cutoff_time)[index2];
              var collection_cutoff = [];
              if(cutoff_time[collection_name] != null){
                collection_cutoff = cutoff_time[collection_name].split(",");
                collection_cutoff = collection_cutoff.map((value) => value.trim());
                collection_cutoff = collection_cutoff.filter((value) => value != '')
              }
              for(index3 = 0; index3 < collection_cutoff.length; index3++) {
                var cutoff_timestamp = DateTime.fromFormat(collection_cutoff[index3], 'dd-MM-yyyy HH:mm').setZone("Asia/Kuala_Lumpur");
                var time = global_cutoff_time.trim()
                var global_cutoff_timestamp = DateTime.fromString(time, 'HH:mm').setZone("Asia/Kuala_Lumpur");

                // if collection cut-off time put 00:00 direct push the date to disable date
                if(cutoff_timestamp.toFormat('HH:mm') == '00:00'){
                  cutoff_dates.push(cutoff_timestamp.toFormat('dd-MM-yyyy'));
                }

                // check the collection cut-off time if is today and hour is bigger than cut-off time push the date to disable date
                if(cutoff_timestamp.toFormat('dd-MM-yyyy') == today_date.toFormat('dd-MM-yyyy') && today_date.hour > cutoff_timestamp.hour){
                  cutoff_dates.push(cutoff_timestamp.toFormat('dd-MM-yyyy'));
                }

                // if the collection cut-off date is able to let client choose. mostly is future date
                if(disable_dates.includes(cutoff_timestamp.toFormat('dd-MM-yyyy'))){
                  disable_dates = disable_dates.filter((element) => element !== cutoff_timestamp.toFormat('dd-MM-yyyy'));
                }

                // if today hour is smaller then global cut-off hour remove today date
                if(global_cutoff_timestamp.hour < cutoff_timestamp.hour && cutoff_timestamp.toFormat('dd-MM-yyyy') == today_date.toFormat('dd-MM-yyyy') && today_date.hour < cutoff_timestamp.hour) {
                  cutoff_dates = cutoff_dates.filter((element) => element !== today_date.toFormat('dd-MM-yyyy'));
                }
              }
            }
          }
        }
    }

    disable_dates = disable_dates.concat(cutoff_dates)
    
    $(".order__dates-item-day").flatpickr({
      inline: !0,
      minDate: "today",
      dateFormat: "d-m-Y",
      disable: disable_dates,
      onChange: function(e, t, a) {
        $('#delivery-date-text').text(t)
        $('.delivery-date-texta').text(t)
        $('[data-date-saver][name="attributes[Delivery Date:]"]').val(t)
        $(".flatpickr-calendar.inline").hide()
        $(".flatpickr-calendar.inline").parents('.order__dates-col').addClass('active')
        $('.order__dates-item.calendar-box').removeClass('activeAdd');
        $("[data-error-msg]").hide();
      }
    });
        $(".flatpickr-calendar.inline").show()
  });
  
   
  $('body').on('change', '#occ[data-occasion]', function(){
    $(this).parents('.date-time-msg').find('[name="attributes[Message:]"]').val( $(this).val() ); 
    $(this).parents('.date-time-msg').find('[name="attributes[Topic:]"]').val($(this).find('[value="'+$(this).val()+'"]').text());
  });
  
    $('body').on('keyup', '.Cart__Note[name="attributes[Message:]"]', function(){
    $(this).parents('.date-time-msg').find('[name="attributes[Message:]"]').val($(this).val());

  });
  
  $('body').on('change', '[name="attributes[Delivery Time:]"]', function(){
    $('.order__session-col').removeClass('active')
    $(this).parents('.order__session-col').addClass('active')
    
  });

  $('body').on('click', '[action="submit_cart_form"]', function(){
    $(this).parents('.widget_shopping_cart').find('#cart_main_form').trigger('submit')
  });
  
  $('body').on('submit', '#cart_main_form', function(event){
     event.preventDefault();
      
     var date_selected = $(".calendar-box [data-date-selected]").text();
     var length = $('#delivery-date-text').text();     
     var cart_count = +$("[data-from-cart-count]").attr("data-from-cart-count") ;
     var disable_dates = $('[data-disable-dates]').text() ;
     var global_cutoff_time = $('[data-global-collection-cutoff]').text();
     var collection_banned = $('[data-collection-banned]').text();
     var collection_cutoff = [];
     var cut_off_date = [];
     var colletions = [];
     var collection_name = '';
     var cutoff_timestamp = '';
     var selected_timestamp = DateTime.fromString(date_selected, 'dd-MM-yyyy');
     var transform_collection_cutoff = [];
     var duplicate_collection_cutoff = [];
     var cutoff = [];
    
      if(typeof disable_dates === 'string'){
        disable_dates = disable_dates.split(",")
        disable_dates.pop()
        disable_dates = disable_dates.map((value) => value.trim())
      }

      if(typeof cutoff_time == 'string'){
        cutoff_time = JSON.parse(cutoff_time)
      }

      if(typeof collection_banned == 'string'){
        collection_banned = collection_banned.split(",")
        collection_banned = collection_banned.map((value) => value.trim())
      }
      
      if(typeof cart_collection == 'string'){
        cart_collection = JSON.parse(cart_collection)
      }

     if(now_timestamp > DateTime.fromString(global_cutoff_time.trim(), 'HH:mm').toMillis()){
        console.log('global block')
        cut_off_date.push(today_date.toFormat('dd-MM-yyyy'))
     }
    
     if (date_selected != '' ){
        if(Object.keys(cutoff_time).length > 0 && Object.values(cart_collection).length > 0){
          for (let index = 0; index < Object.values(cart_collection).length; index++) {
                colletions = Object.values(cart_collection)[index];
                for (let index2 = 0; index2 < Object.keys(cutoff_time).length; index2++) {
                  if(Object.values(colletions).find((ele) => ele === Object.keys(cutoff_time)[index2]) != undefined){
                    collection_name = Object.keys(cutoff_time)[index2];
                    if(cutoff_time[collection_name] != null){
                      cutoff = cutoff_time[collection_name].split(",");
                      collection_cutoff = collection_cutoff.concat(cutoff)
                      collection_cutoff = collection_cutoff.map((value) => value.trim());
        
                    for(time = 0; time < collection_cutoff.length; time++) {
                      cutoff_timestamp = DateTime.fromFormat(collection_cutoff[time], 'dd-MM-yyyy HH:mm');
                      transform_collection_cutoff = collection_cutoff.map((value) => DateTime.fromFormat(value, 'dd-MM-yyyy HH:mm').toFormat('dd-MM-yyyy'))
                      duplicate_collection_cutoff = findDuplicates(transform_collection_cutoff);
                      var globalTime = global_cutoff_time.trim()
                      var global_cutoff_timestamp = DateTime.fromString(globalTime, 'HH:mm')

                      if(selected_timestamp.toFormat('dd-MM-yyyy') === cutoff_timestamp.toFormat('dd-MM-yyyy')){
                        if(now_timestamp > cutoff_timestamp.toMillis()){
                          console.log('today date collection block')
                          $("[data-error-msg]").show();
                          $('.order__dates-item.calendar-box').addClass('activeAdd');
                
                         return '';
                        }
                        
                        if(cutoff_timestamp.toFormat('HH:mm') == '00:00'){
                          console.log('all day collection block')
                          $("[data-error-msg]").show();
                          $('.order__dates-item.calendar-box').addClass('activeAdd');
                
                         return '';
                        }
              
                        if(selected_timestamp.toMillis() > cutoff_timestamp.toMillis()){
                            console.log('future date collection block')
                            $("[data-error-msg]").show();
                            $('.order__dates-item.calendar-box').addClass('activeAdd');
                  
                            return '';
                        }

                        if(global_cutoff_timestamp.toMillis() < cutoff_timestamp.toMillis() && cutoff_timestamp.toFormat('dd-MM-yyyy') == today_date.toFormat('dd-MM-yyyy') && now_timestamp < cutoff_timestamp.toMillis()){
                          cut_off_date = cut_off_date.filter((element) => element !== today_date.toFormat('dd-MM-yyyy'));
                        }

                        if(cart_count > 1){
                          disable_dates = disable_dates.filter((element) => !duplicate_collection_cutoff.includes(element));
                        }else{
                          disable_dates = disable_dates.filter((element) => element !== selected_timestamp.toFormat('dd-MM-yyyy'));
                        }
                      }
                    }
                      
                    if(collection_banned.length > 0){
                      for(collection = 0; collection < collection_banned.length; collection++){
                        console.log(cutoff_time.hasOwnProperty(collection_banned[collection]) , disable_dates.includes(date_selected))
                        if(cutoff_time.hasOwnProperty(collection_banned[collection]) && disable_dates.includes(date_selected)){
                          cut_off_date.push(date_selected)
                        }
                      }
                    }
                }
              }         
            }
          }
        }
       // console.log(cutoff_time)
       if(cutoff_time.hasOwnProperty('CNY') && cutoff_time.hasOwnProperty('VALENTINE')){
          var cny = cutoff_time['CNY'].split(",");
          var valentine = cutoff_time['VALENTINE'].split(",");
          var array = cny.concat(valentine)
          array = array.map((value) => value.trim());
          array = array.map((value) => DateTime.fromFormat(value, 'dd-MM-yyyy HH:mm').toFormat('dd-MM-yyyy'));
          var different = findNonDuplicate(array);
          
          cut_off_date = cut_off_date.concat(different)
        }

        if(cutoff_time.hasOwnProperty('MOTHER DAY') && cutoff_time.hasOwnProperty('HARI RAYA')){
          var cny = cutoff_time['MOTHER DAY'].split(",");
          var valentine = cutoff_time['HARI RAYA'].split(",");
          var array = cny.concat(valentine)
          array = array.map((value) => value.trim());
          array = array.map((value) => DateTime.fromFormat(value, 'dd-MM-yyyy HH:mm').toFormat('dd-MM-yyyy'));
          var different = findNonDuplicate(array);
          
          cut_off_date = cut_off_date.concat(different)
        }
          
        disable_dates = disable_dates.concat(cut_off_date)
       
       if (disable_dates.includes(date_selected)) {
           console.log('disabled dates')
            $("[data-error-msg]").show();
            $('.order__dates-item.calendar-box').addClass('activeAdd');
  
           return '';
        }
     
       $.ajax({
        type: 'POST', 
        url: '/cart',
        dataType: 'json', 
        data: $(this).serialize(),
        success: function(data){                    
          //window.location.href = '/cart'
          window.location.href = '/collections/add-on-chocolate'
        },
        error: function(){}
      });
       
    } else {
      $('.order__dates-item.calendar-box').addClass('activeAdd');
      return false;
    }});

  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function(e) {
      e.preventDefault();

      var date_selected = $(".calendar-box [data-date-selected]").text();
      var disable_dates = $('[data-disable-dates]').text();
      var cart_count = +$("[data-from-cart-count]").attr("data-from-cart-count");
      var global_cutoff_time = $('[data-global-collection-cutoff]').text();
      var collection_banned = $('[data-collection-banned]').text();
      var collection_cutoff = [];
      var cut_off_date = [];
      var colletions = [];
      var collection_name = '';
      var cutoff_timestamp = '';
      var selected_timestamp = DateTime.fromString(date_selected, 'dd-MM-yyyy');
      var transform_collection_cutoff = [];
      var duplicate_collection_cutoff = [];
      var cutoff = [];

      if(typeof disable_dates === 'string'){
        disable_dates = disable_dates.split(",")
        disable_dates.pop()
        disable_dates = disable_dates.map((value) => value.trim())
      }

      if(typeof collection_banned == 'string'){
        collection_banned = collection_banned.split(",")
        collection_banned = collection_banned.map((value) => value.trim())
      }

      if(typeof cutoff_time == 'string'){
        cutoff_time = JSON.parse(cutoff_time)
      }
      
      if(typeof cart_collection == 'string'){
        cart_collection = JSON.parse(cart_collection)
      }

      if(now_timestamp > DateTime.fromString(global_cutoff_time.trim(), 'HH:mm').toMillis()){
        console.log('global block')
        cut_off_date.push(today_date.toFormat('dd-MM-yyyy'))
      }
    
      if(Object.keys(cutoff_time).length > 0 && Object.values(cart_collection).length > 0){
          for (let index = 0; index < Object.values(cart_collection).length; index++) {
                colletions = Object.values(cart_collection)[index];
                for (let index2 = 0; index2 < Object.keys(cutoff_time).length; index2++) {
                  if(Object.values(colletions).find((ele) => ele === Object.keys(cutoff_time)[index2]) != undefined){
                    collection_name = Object.keys(cutoff_time)[index2];
                    if(cutoff_time[collection_name] != null){
                      cutoff = cutoff_time[collection_name].split(",");
                      collection_cutoff = collection_cutoff.concat(cutoff)
                      collection_cutoff = collection_cutoff.map((value) => value.trim());
        
                    for(time = 0; time < collection_cutoff.length; time++) {
                      cutoff_timestamp = DateTime.fromFormat(collection_cutoff[time], 'dd-MM-yyyy HH:mm');
                      transform_collection_cutoff = collection_cutoff.map((value) => DateTime.fromFormat(value, 'dd-MM-yyyy HH:mm').toFormat('dd-MM-yyyy'))
                      duplicate_collection_cutoff = findDuplicates(transform_collection_cutoff);
                      var globalTime = global_cutoff_time.trim()
                      var global_cutoff_timestamp = DateTime.fromString(globalTime, 'HH:mm')

                      if(selected_timestamp.toFormat('dd-MM-yyyy') === cutoff_timestamp.toFormat('dd-MM-yyyy')){
                        if(now_timestamp > cutoff_timestamp.toMillis()){
                          console.log('today date collection block')
                          $("[data-error-msg]").show();
                          $('.order__dates-item.calendar-box').addClass('activeAdd');
                
                         return '';
                        }
                        
                        if(cutoff_timestamp.toFormat('HH:mm') == '00:00'){
                          console.log('all day collection block')
                          $("[data-error-msg]").show();
                          $('.order__dates-item.calendar-box').addClass('activeAdd');
                
                         return '';
                        }
              
                        if(selected_timestamp.toMillis() > cutoff_timestamp.toMillis()){
                            console.log('future date collection block')
                            $("[data-error-msg]").show();
                            $('.order__dates-item.calendar-box').addClass('activeAdd');
                  
                            return '';
                        }

                        if(global_cutoff_timestamp.toMillis() < cutoff_timestamp.toMillis() && cutoff_timestamp.toFormat('dd-MM-yyyy') == today_date.toFormat('dd-MM-yyyy') && now_timestamp < cutoff_timestamp.toMillis()){
                          cut_off_date = cut_off_date.filter((element) => element !== today_date.toFormat('dd-MM-yyyy'));
                        }

                        if(cart_count > 1){
                          disable_dates = disable_dates.filter((element) => !duplicate_collection_cutoff.includes(element));
                        }else{
                          disable_dates = disable_dates.filter((element) => element !== selected_timestamp.toFormat('dd-MM-yyyy'));
                        }
                      }
                    }

                    if(collection_banned.length > 0){
                      for(collection = 0; collection < collection_banned.length; collection++){
                        // console.log(cutoff_time.hasOwnProperty(collection_banned[collection]) , disable_dates.includes(date_selected))
                        if(cutoff_time.hasOwnProperty(collection_banned[collection]) && disable_dates.includes(date_selected)){
                          cut_off_date.push(date_selected)
                        }
                      }
                    }
                }
              }        
            }
          }
        }

        if(cutoff_time.hasOwnProperty('CNY') && cutoff_time.hasOwnProperty('VALENTINE')){
          var cny = cutoff_time['CNY'].split(",");
          var valentine = cutoff_time['VALENTINE'].split(",");
          var array = cny.concat(valentine)
          array = array.map((value) => value.trim());
          array = array.map((value) => DateTime.fromFormat(value, 'dd-MM-yyyy HH:mm').toFormat('dd-MM-yyyy'));
          var different = findNonDuplicate(array);
          
          cut_off_date = cut_off_date.concat(different)
        }

        if(cutoff_time.hasOwnProperty('MOTHER DAY') && cutoff_time.hasOwnProperty('HARI RAYA')){
          var cny = cutoff_time['MOTHER DAY'].split(",");
          var valentine = cutoff_time['HARI RAYA'].split(",");
          var array = cny.concat(valentine)
          array = array.map((value) => value.trim());
          array = array.map((value) => DateTime.fromFormat(value, 'dd-MM-yyyy HH:mm').toFormat('dd-MM-yyyy'));
          var different = findNonDuplicate(array);
          
          cut_off_date = cut_off_date.concat(different)
        }
    
        disable_dates = disable_dates.concat(cut_off_date)

       if (disable_dates.includes(date_selected)) {
           console.log('disabled dates')
            $("[data-error-msg]").show();
            $('.order__dates-item.calendar-box').addClass('activeAdd');
  
           return '';
        }
      
        $("[data-error-msg]").hide();
        $('.order__dates-item.calendar-box').removeClass('activeAdd'); 
        $(this).parents('form[action="/checkout"]').trigger('submit')

//         window.location.href = '/checkout';
      
    });
});


